import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FiArrowUp } from 'react-icons/fi';

import Nav from './components/Nav';
import Minatechnologies from './components/minatechnologies';
import Aboutminatechnologies from './components/Aboutminatechnologies2';
import Services from './components/Servicesminatechnologies2';
import Whyus from './components/Whyus2';
import Teams from './components/Teams';
import Portfolio from './components/Portfolio';
import Security from './components/Security';
import Contactus from './components/Contactus';
import Footer from './components/Footer';

import "./App.css"

function App2() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>mina technologies</title>
        <meta property="title" content="mina technologies" />
        <meta name="description" content="mina technologies is a visionary, next-generation technology company dedicated to innovating and shaping the future of digital solutions."/>
        <link rel='canonical' href='/'></link>
        <meta name="keywords" content="mina, mina technologies, web development,website development ethiopia,technologies,website development,technology,ethiopia technology,software development,mobile app development" />
        <meta name="og:keywords" content="mina, mina technologies, web development,website development ethiopia,technologies,website development,technology,ethiopia technology,software development,mobile app development" />
        <meta property="og:title" content="mina technologies" />
        <meta property="og:description" content="mina technologies is a visionary, next-generation technology company dedicated to innovating and shaping the future of digital solutions." />
        <meta property="og:image" content="%PUBLIC_URL%/mina4.jpg" />
      </Helmet>

      <div className="App bg-surface font-sans text-ink">
        <Nav />

        <main>
          <section id="home">
            <Minatechnologies />
          </section>
          <section id="about">
            <Aboutminatechnologies />
          </section>
          <section id="services">
            <Services />
          </section>
          <section id="whyus">
            <Whyus />
          </section>
          <section id="team">
            <Teams />
          </section>
          <section id="portfolio">
            <Portfolio />
          </section>
          <section id="security">
            <Security />
          </section>
          <section id="contactus">
            <Contactus />
          </section>
        </main>

        <Footer />

        <button
          type="button"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className={`fixed bottom-6 right-6 z-40 inline-grid h-12 w-12 place-items-center rounded-full bg-ink text-white shadow-float ring-1 ring-white/10 transition-all duration-300 hover:bg-brand ${
            showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'
          }`}
        >
          <FiArrowUp size={20} />
        </button>
      </div>
    </>
  );
}

export default App2;
